export const folderCreditInfoFragment = `
    id
    activeGroups {
        group {
            name
            type
        }
    }
    creditBalance
`;
